<template>
  <svg
    preserveAspectRatio="xMidYMid meet"
    :viewBox="`0 0 ${containerWidth} ${containerHeight}`"
    class="gameplay-differences"
  >
    <g>
      <component
        v-bind:is="component"
        :image="imageLeft"
        :found-items="foundItems"
        :found-items-hints="foundItemsHints"
        @foundItem="foundItem"
        @missedItem="missedItem"
        :x="x1"
        :y="y1"
        :width="653"
        :height="355"
        :isLeft="true"
      />
      <component
        v-bind:is="component"
        :image="imageRight"
        :found-items="foundItems"
        :found-items-hints="foundItemsHints"
        @foundItem="foundItem"
        @missedItem="missedItem"
        :x="x2"
        :y="y2"
        :width="653"
        :height="355"
        :isLeft="false"
      />
    </g>
  </svg>
</template>

<script>
import s1e1 from "@/sessions/session1/p1";
import s1e2 from "@/sessions/session1/p2";
import s1e3 from "@/sessions/session1/p3";
import s2e1 from "@/sessions/session2/p1";
import s2e2 from "@/sessions/session2/p2";
import s2e3 from "@/sessions/session2/p3";
import s3e1 from "@/sessions/session3/p1";
import s3e2 from "@/sessions/session3/p2";
import s3e3 from "@/sessions/session3/p3";
import s4e1 from "@/sessions/session4/p1";
import s4e2 from "@/sessions/session4/p2";
import s4e3 from "@/sessions/session4/p3";

const data = [
  {
    component: "s1e1",
    left: require("@/sessions/session1/p1_l.jpg"),
    right: require("@/sessions/session1/p1_r.jpg")
  },
  {
    component: "s1e2",
    left: require("@/sessions/session1/p2_l.jpg"),
    right: require("@/sessions/session1/p2_r.jpg")
  },
  {
    component: "s1e3",
    left: require("@/sessions/session1/p3_l.jpg"),
    right: require("@/sessions/session1/p3_r.jpg")
  },
  //
  {
    component: "s2e1",
    left: require("@/sessions/session2/p1_l.jpg"),
    right: require("@/sessions/session2/p1_r.jpg")
  },
  {
    component: "s2e2",
    left: require("@/sessions/session2/p2_l.jpg"),
    right: require("@/sessions/session2/p2_r.jpg")
  },
  {
    component: "s2e3",
    left: require("@/sessions/session2/p3_l.jpg"),
    right: require("@/sessions/session2/p3_r.jpg")
  },
  //
  {
    component: "s3e1",
    left: require("@/sessions/session3/p1_l.jpg"),
    right: require("@/sessions/session3/p1_r.jpg")
  },
  {
    component: "s3e2",
    left: require("@/sessions/session3/p2_l.jpg"),
    right: require("@/sessions/session3/p2_r.jpg")
  },
  {
    component: "s3e3",
    left: require("@/sessions/session3/p3_l.jpg"),
    right: require("@/sessions/session3/p3_r.jpg")
  },
  //
  {
    component: "s4e1",
    left: require("@/sessions/session4/p1_l.jpg"),
    right: require("@/sessions/session4/p1_r.jpg")
  },
  {
    component: "s4e2",
    left: require("@/sessions/session4/p2_l.jpg"),
    right: require("@/sessions/session4/p2_r.jpg")
  },
  {
    component: "s4e3",
    left: require("@/sessions/session4/p3_l.jpg"),
    right: require("@/sessions/session4/p3_r.jpg")
  }
];

import { ActivitySize } from "@/store";

const SECTION_WIDTH = 653;
const SECTION_HEIGHT = 355;

export default {
  components: {
    s1e1,
    s1e2,
    s1e3,
    s2e1,
    s2e2,
    s2e3,
    s3e1,
    s3e2,
    s3e3,
    s4e1,
    s4e2,
    s4e3
  },
  methods: {
    foundItem(id) {
      this.$emit("foundItem", id);
    },
    missedItem() {
      this.$emit("missedItem");
    }
  },
  computed: {
    imageLeft() {
      return data[this.game].left;
    },
    imageRight() {
      return data[this.game].right;
    },
    isHorizontal() {
      return (
        this.$store.state.size === ActivitySize.DESKTOP ||
        this.$store.state.size === ActivitySize.TABLET
      );
    },
    foundItems() {
      return this.$store.state.game.foundItems;
    },
    foundItemsHints() {
      return this.$store.state.game.foundItemsHints;
    },
    game() {
      return this.$store.state.game.game;
    },
    containerWidth() {
      return this.isHorizontal ? SECTION_WIDTH * 2 + 10 : SECTION_WIDTH;
    },
    containerHeight() {
      return this.isHorizontal ? SECTION_HEIGHT : SECTION_HEIGHT * 2 + 10;
    },
    x1() {
      return 0;
    },
    y1() {
      return 0;
    },
    x2() {
      return this.isHorizontal ? SECTION_WIDTH + 10 : 0;
    },
    y2() {
      return this.isHorizontal ? 0 : SECTION_HEIGHT + 10;
    },
    component() {
      return data[this.game].component;
    }
  }
};
</script>

<style lang="scss" scoped>
.gameplay-differences {
  width: 100%;
  margin: 0 auto rems(10px) auto;
  cursor: pointer;
  user-select: none;
  -webkit-tap-highlight-color: rgba(255, 255, 255, 0);
}
.gameplay-differences {
  width: 100%;
  margin: 0 auto;
  cursor: pointer;
}
</style>
